export enum GradeType {
  A = "A",
  B = "B",
  C = "C",
  SFX = "SFX"
}
